import $ from 'jquery';
import Rails from '@rails/ujs';
import '@rails/actiontext';
import Turbolinks from 'turbolinks';
import { start as startActiveStorage } from '@rails/activestorage';
import 'channels';
import 'bootstrap';
import '@fortawesome/fontawesome-free/css/all';
import 'trix';

import '../trix-editor-overrides';
import 'stylesheets/application.scss';
import '../security_password_validation';
import '../registration_validation';

import { Tooltip, Popover } from 'bootstrap';

import React from 'react';
import { createRoot } from 'react-dom/client';
import InvitationForm from 'Invitations/InvitationForm';

Rails.start();
// Turbolinks.start();
startActiveStorage();

window.$ = $;
window.jQuery = $;

window.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('invitation-form-root');
  if (node) {
    const root = createRoot(node);
    root.render(<InvitationForm />);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
  });

  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  var popoverList = popoverTriggerList.map(function(popoverTriggerEl) {
    return new Popover(popoverTriggerEl);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".stripe-plan-card").forEach(card => {
    console.log("Stripe card found:", card); // for debugging
    card.addEventListener("click", (e) => {
      e.preventDefault();
      const planId = card.dataset.planId;
      if (!planId) return;
      window.location.href = card.dataset.url;
    });
  });
});
